<span class="txt">{{locale "viewing"}} {{ recordRangeStart }}-{{ recordRangeEnd }} {{locale "of"}} {{ totalRecords }} {{ resultsName }}</span>